/* eslint-disable object-shorthand */
/* eslint-disable func-names */
/* eslint-disable react/no-this-in-sfc */
import {
  FatSelectItem,
  Select,
  SelectContent,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "components/ui/Select";
import classNames from "components/ui/classNames";
import { useIntl } from "react-intl";

interface SingleValueSelectProps {
  value: string;
  placeholder?: string;
  disabled?: boolean;
  canReset?: boolean;
  onChange: (value: string) => void;
  values: {
    value: string;
    label: string;
    description?: string;
  }[];
}

export default function SingleValueSelect({
  value,
  onChange,
  values,
  disabled,
  canReset,
  placeholder,
}: SingleValueSelectProps) {
  const intl = useIntl();
  const defaultPlaceholder = intl.formatMessage({
    defaultMessage: "Selecionar",
    description: "Valor padrão do campo",
    id: "1DaLxH",
  });
  const selected = values.find((candidate) => {
    return candidate.value === value;
  });
  return (
    <Select value={value || "ALL"} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger
        className={classNames(
          "font-aeonik",
          "w-full rounded-xl",
          "border border-slate-200 bg-white",
          "text-sm font-medium tracking-wide text-slate-600",
          "disabled:select-none",
          "hover:border-transparent hover:ring-4 hover:ring-slate-100 hover:ring-offset-1 hover:ring-offset-slate-300",
          "focus-visible:border-transparent focus-visible:ring-4 focus-visible:ring-offset-1",
          "focus-visible:ring-indigo-100 focus-visible:ring-offset-indigo-300",
          "truncate",
        )}
      >
        <SelectValue placeholder={placeholder}>
          {selected ? selected.label : placeholder || defaultPlaceholder}
        </SelectValue>
      </SelectTrigger>

      <SelectContent
        scrollAreaClassName="max-h-96"
        className="max-h-52 rounded-lg border border-slate-300 text-sm shadow-xl"
        side="top"
      >
        {canReset && (
          <>
            <FatSelectItem key={value} className="cursor-pointer rounded-xl p-3 px-3 text-sm" value="">
              <div className="space-y-1 font-aeonik">
                <h4 className="text-xs font-bold text-slate-600">{placeholder || defaultPlaceholder}</h4>
              </div>
            </FatSelectItem>
            <SelectSeparator />
          </>
        )}

        {values.map(({ value, label }) => (
          <FatSelectItem key={value} className="cursor-pointer rounded-xl p-3 px-3 text-sm" value={value}>
            <div className="space-y-1 font-aeonik">
              <h4 className="text-xs font-bold text-slate-600">{label}</h4>
              {/* {description && <p className="max-w-xs truncate text-xs tracking-wide text-slate-500">{description}</p>} */}
            </div>
          </FatSelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
